import { CompanyTemplateVariable } from '@reach/shared-types/template-variables';
import type { StripoMergeField } from './stripo.types';

const COMPANY_FIELD_LABELS: Record<CompanyTemplateVariable, string> = {
  [CompanyTemplateVariable.COMPANY_NAME]: 'Company Name',
  [CompanyTemplateVariable.COMPANY_WEBSITE]: 'Company Website',
  [CompanyTemplateVariable.COMPANY_PRIMARY_COLOR]: 'Company Primary Color',
  [CompanyTemplateVariable.COMPANY_LOGO_URL]: 'Company Logo URL',
  [CompanyTemplateVariable.COMPANY_EMAIL]: 'Company Email',
  [CompanyTemplateVariable.COMPANY_PHONE]: 'Company Phone',
  [CompanyTemplateVariable.COMPANY_EXTERNAL_ID]: 'Company External ID',
};

export const TEMPLATE_MERGE_FIELDS: StripoMergeField[] = [
  {
    category: 'Standard Customer Fields',
    entries: [
      { label: 'First Name', value: '{{First Name}}' },
      { label: 'Last Name', value: '{{Last Name}}' },
      { label: 'Email', value: '{{Email}}' },
      { label: 'Phone', value: '{{Phone}}' },
    ],
  },
  {
    category: 'Custom Fields',
    entries: [
      { label: 'Birthday', value: '{{Birthday}}' },
      { label: 'Lifetime Value', value: '{{Lifetime Value}}' },
      { label: 'Pet Type', value: '{{Pet Type}}' },
      { label: 'Last Purchase Date', value: '{{Last Purchase Date}}' },
      { label: 'Loyalty Tier', value: '{{Loyalty Tier}}' },
    ],
  },
  {
    category: 'Business Fields',
    entries: Object.values(CompanyTemplateVariable).map(value => ({
      label: COMPANY_FIELD_LABELS[value],
      value,
    })),
  },
];

export const TEMPLATE_MERGE_FIELDS_PLACEHOLDERS: string[] = TEMPLATE_MERGE_FIELDS.reduce(
  (acc, category) => {
    return [...acc, ...category.entries.map(entry => entry.value)];
  },
  [] as string[],
);
